export const sources = {
	avif: "__VITE_ASSET__B$1KRWp___ 134w",
	webp: "__VITE_ASSET__C$lMmg5J__ 134w"
};
export const img = {
	src: "__VITE_ASSET__Vx2cOk2o__",
	w: 134,
	h: 199
};
export default {
	sources: sources,
	img: img
};
